module.exports = __webpack_public_path__ + "static/media/XRMALOD1.03a5a3e1.png";